import { render, staticRenderFns } from "./BanqList.vue?vue&type=template&id=50c750ae&scoped=true&"
import script from "./BanqList.vue?vue&type=script&lang=js&"
export * from "./BanqList.vue?vue&type=script&lang=js&"
import style0 from "./BanqList.vue?vue&type=style&index=0&id=50c750ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c750ae",
  null
  
)

export default component.exports